function isString(value) {
  return typeof value === 'string' || value instanceof String;
}

export { isString as i };
//# sourceMappingURL=isString-D4CFRAVS-D4CFRAVS.js.map
